import styled from 'styled-components';

const Footer = styled.div`
  position: relative;
`;

export default Footer;
